import ProjectGalleryCategories from "@components/pages/project-gallery/project-gallery-categories"
import Layout from "components/layout"
import Seo from "components/seo"
import { F_Q_GALLERY_CATEGORIES } from "lib/function"
import Helmet from "react-helmet"

export default function HomePage({ data, locale }) {
  return (
    <>
      <Seo
        title={locale === "en" ? "Project Gallery & Events" : "Proyek & Event"}
      />
      <Helmet>
        <body className="bd-project-gallery" />
      </Helmet>
      <Layout>
        <ProjectGalleryCategories categories={data} />
      </Layout>
    </>
  )
}

export const getStaticProps = async (ctx) => {
  let token = process.env.INIT_TOKEN
  let { locale } = ctx
  let data = await F_Q_GALLERY_CATEGORIES({ lang: locale }, token)
  return {
    props: {
      locale,
      data: data?.data?.galleryCategories ?? null,
      token,
    },
    revalidate: 60,
  }
}
